<template>
    <div style="display: flex; flex-direction: column; align-items: center;">
        <div v-if="isShowPopup" style="backdrop-filter: blur(13px); position: fixed; left: 0; top: 0; height: 100%; width: 100%; display: flex; flex-direction: column; background-color: #0F0600B2; z-index: 100;">
            <div @click="closePopup" style="padding: 20px; width: 70px;">
                <img style="width: 20px;" :src="require('@/assets/img/x_btn.png')" alt="">
            </div>
            <div v-if="isStep" style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <div style="font-weight: 700; font-size: 26px; line-height: 32px; color: #fff; text-align: center;">앱에 접속하여 포지션 찾기를<br>이어서 진행해 보세요</div>
                <div @click="goToApp" style="width: 320px; background-color: #fff; padding: 14px 0; text-align: center; line-height: 32px; font-weight: 500; border-radius: 60px; margin-top: 64px;">이어서 진행하기</div>
            </div>
            <div v-else style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <div style="font-weight: 700; font-size: 26px; line-height: 32px; color: #fff; text-align: center;">전국의 선수들이 모이는 곳,<br>사커하우 앱에서 확인하기</div>
                <div @click="savePosition" style="width: 320px; background-color: #fff; padding: 14px 0; text-align: center; line-height: 32px; font-weight: 500; border-radius: 60px; margin-top: 64px;">내 프로필에 적용하기</div>
            </div>
        </div>
        <div v-if="isShowQr" style="position: fixed; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; top: 0; left: 0; z-index: 200; background-color: #210f0333;">
            <div style="width: 390px; height:390px; background-color: #fff; border-radius: 24px; position: relative;">
                <div @click="closeQr" style="position: absolute; right: 20px; top: 20px; font-weight: 700; line-height: 24px;">닫기</div>
                <div style="margin-top: 23px; text-align: center;">
                    <img style="width: 70px;" :src="require('@/assets/img/soccerhow_orange.png')" alt="">
                </div>
                <div style="font-weight: 700; line-height: 20px; text-align: center; margin-top: 46px;">QR코드를 스캔하여<br>사커하우 모바일 앱을 다운로드할 수 있습니다.</div>
                <div style="margin-top: 40px; display: flex; justify-content: center; gap: 60px;">
                    <div>
                        <div style="display: flex; gap: 4px; align-items: center; justify-content: center; margin-bottom: 4px;">
                            <img style="width: 17px;" :src="require('@/assets/img/app_store.png')" alt="">
                            <div style="font-weight: 500; font-size: 12px;">앱스토어</div>
                        </div>
                        <img style="width: 100px;" :src="require('@/assets/img/ios_qr.png')" alt="">
                    </div>
                    <div>
                        <div style="display: flex; gap: 4px; align-items: center; justify-content: center; margin-bottom: 4px;">
                            <img style="width: 17px;" :src="require('@/assets/img/play_store.png')" alt="">
                            <div style="font-weight: 500; font-size: 12px;">구글플레이</div>
                        </div>
                        <img style="width: 100px;" :src="require('@/assets/img/android_qr.png')" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div style="background-color: #341A00; width: 100%;">
            <div @click="() => { $GlobalStore.closeLastModal() }" style="padding: 35px 12px;">
                <img style="width: 70px;" :src="require('@/assets/img/title.png')" alt="">
            </div>
        </div>
        <div v-if="isShowResult" style="max-width: 700px; width: 100%; overflow-y: scroll; flex: 1;">
            <div style="padding:0px 20px; margin-top: 60px; min-height: 120px;">
                <div v-html="sentence[step]" style=" font-size:20px; font-weight:500;line-height:28px;text-align:center;"></div>
                <div v-if="step === 12" style="text-align: center; color: #808080; font-size: 14px; margin-top: 4px;">(양발이면 모두 선택)</div>
            </div>
            <div v-if="step !== 12" style="min-height: 250px; text-align: center;">
                <div style="position:relative; white-space: nowrap;" v-for="index in 12" :key="index">
                    <img v-if="index === step && step !== 9" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub_img_ani_unactive${step}` : `step_sub_img_ani_active${step}`" :src="require(`@/assets/img/sub_step${step}.png`)" alt="">
                    <img v-if="index === step" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_img_ani_unactive${step}` : `step_img_ani_active${step}`" :src="require(`@/assets/img/step${step}.png`)" alt="">
                    <img v-if="index === step && (step === 4 || step === 6 || step === 7 || step === 8 || step === 11)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub2_img_ani_unactive${step}` : `step_sub2_img_ani_active${step}`" :src="require(`@/assets/img/sub2_step${step}.png`)" alt="">
                    <img v-if="index === step && (step === 6 || step === 7 || step === 8)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub3_img_ani_unactive${step}` : `step_sub3_img_ani_active${step}`" :src="require(`@/assets/img/sub3_step${step}.png`)" alt="">
                    <img v-if="index === step && (step === 6 || step === 7 || step === 8)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub4_img_ani_unactive${step}` : `step_sub4_img_ani_active${step}`" :src="require(`@/assets/img/sub4_step${step}.png`)" alt="">
                    <img v-if="index === step && (step === 7 || step === 8)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub5_img_ani_unactive${step}` : `step_sub5_img_ani_active${step}`" :src="require(`@/assets/img/sub5_step${step}.png`)" alt="">
                    <img v-if="index === step && (step === 7)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub6_img_ani_unactive${step}` : `step_sub6_img_ani_active${step}`" :src="require(`@/assets/img/sub6_step${step}.png`)" alt="">
                </div>
            </div>
            <div style="width: 100%;">
                <div style="display:flex;align-items: center; justify-content: space-between; gap: 12px; padding: 0 40px;" v-if="step >= 0 && step < 12">
                    <div @click="setScore(1)" :class="[scores[step] === 1 ? 'active' : '']" class="common_btn">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">매우 <span style="white-space: nowrap;">아니다</span></div>
                    </div>
                    <div @click="setScore(2)" :class="[scores[step] === 2 ? 'active' : '']" class="common_btn">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">아니다</div>
                    </div>
                    <div @click="setScore(3)" :class="[scores[step] === 3 ? 'active' : '']" class="common_btn">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">중간</div>
                    </div>
                    <div @click="setScore(4)" :class="[scores[step] === 4 ? 'active' : '']" class="common_btn">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">그렇다</div>
                    </div>
                    <div @click="setScore(5)" :class="[scores[step] === 5 ? 'active' : '']" class="common_btn">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">매우 <span style="white-space: nowrap;">그렇다</span></div>
                    </div>
                </div>
                <div style="display:flex; justify-content: center; gap: 68px; align-items: center; padding:20px; padding-top: 0; padding-bottom: 40px;" v-if="step === 12">
                    <div style="text-align: center; cursor: pointer;" @click="setFootScore(1)">
                        <div style="margin-bottom: 16px; font-weight: 500; color: #fff;">왼발</div>
                        <div>
                            <img style="width: 90px;" :src="leftFoot ? require('@/assets/img/left_foot_on.png') : require('@/assets/img/left-foot-off.png')" alt="">
                        </div>
                    </div>
                    <div style="text-align: center; cursor: pointer;" @click="setFootScore(3)">
                        <div style="margin-bottom: 16px; font-weight: 500; color: #fff">오른발</div>
                        <div>
                            <img style="width: 90px;" :src="rightFoot ? require('@/assets/img/right_foot_on.png') : require('@/assets/img/right-foot-off.png')" alt="">
                        </div>
                    </div>
                </div>
                <div style="padding: 0 40px; margin-top: 16px;" v-if="step > 0 && step < 13">
                    <div style="height:16px; background-color: #f5f5f5; border-radius:50px;width:100%;position:relative; overflow:hidden;">
                        <div style="position:absolute; transition: 0.2s all; left:0px;background-color: var(--color-main);height: 100%;  border-radius:4px;" :style="{ width: parseInt((step) / 12 * 100) + '%' }"></div>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 8px; padding: 0 40px;">
                    <div>
                        <img style="width: 56px;" :src="require('@/assets/img/soccerhow_orange.png')" alt="">
                        <div style="margin-top: 4px; font-size: 10px; font-weight: 500; line-height: 12px; color: #606060;">포지션 찾기 Lite</div>
                    </div>
                    <!-- <div class="next_btn" @click="next(null, scores[step + 1])">{{ step === 12 ? '결과 보기' : '다음' }}</div> -->
                    <div style="flex-basis: 55%; display: flex; gap: 12px;">
                        <div @click="prevStep" v-if="step >= 2 && step !== 12" style="background-color: #ededed; flex: 1;" class="next_btn">이전</div>
                        <div style="flex: 1;" class="next_btn" @click="next(null, scores[step + 1])">{{ step === 12 ? '결과 보기' : '다음' }}</div>
                    </div>
                </div>
            </div>
            <!-- <template v-if="step !== 14">
                <div style="background-color: #fff;padding-bottom: 20px; padding-top: 20px; display: flex; gap: 20px" v-if="step >= 0 && step < 13">
                    <div @click="prevStep" v-if="step >= 2" class="prev_btn">
                        <div>이전</div>
                    </div>
                    <div style="text-align:center; flex: 1">

                    </div>
                </div>
            </template> -->
        </div>
        <div v-else style="width: 100%; flex: 1;  overflow-y: scroll;">
            <div style="padding:20px; padding-bottom: 0; max-width: 700px; margin: 0 auto;">
                <div style="margin-top: 40px;">
                    <div style="border-bottom: 1px solid #ededed; padding-bottom: 32px; text-align: center;">
                        <div style="font-size:24px; font-weight: 500;">포지션 유형</div>
                        <div style="display: flex; margin-top: 16px; justify-content: center;">
                            <div>
                                <div style="font-size:32px; font-weight:700;">{{ result[position].explanation[2] }}</div>
                                <div style="margin-top: 10px; font-weight: 500; font-size: 12px; color: #606060;">Striker / Centre-forward</div>
                            </div>
                        </div>
                        <div style="margin-top: 32px;">
                            <img style="width: 226px;" :src="result[position].titleImage" alt="">
                        </div>
                    </div>
                    <div style="">
                        <div style="margin-top: 32px;">
                            <div style="margin-bottom: 8px; font-size: 20px; font-weight: 500;">월드클래스 {{ result[position].explanation[0] }} 선수</div>
                            <div style="line-height: 28px; font-weight: 500;">회원님의 포지션에서 뛰는 대표적인 선수들입니다</div>
                        </div>
                        <div style="display:flex; justify-items: center; gap: 50px; margin-top: 16px;">
                            <div class="hide_scroll" style="display:flex; text-align:center; overflow-x: scroll; overflow-y: hidden; margin: 0 -20px; padding: 0 20px; gap: 12px; border-bottom: 1px solid #ededed; padding-bottom: 32px;">
                                <div style="">
                                    <img :src="result[position].images[0]" style="width:150px; border-radius: 49%;">
                                    <div class="player_name">{{ result[position].names[0] }}</div>
                                </div>
                                <div style="">
                                    <img :src="result[position].images[2]" style="width:150px; border-radius: 49%;">
                                    <div class="player_name">{{ result[position].names[2] }}</div>
                                </div>
                                <div style="">
                                    <img :src="result[position].images[1]" style="width:150px; border-radius: 49%;">
                                    <div class="player_name">{{ result[position].names[1] }}</div>
                                </div>
                                <div>
                                    <img :src="result[position].images[3]" style="width:150px; border-radius: 49%;">
                                    <div class="player_name">{{ result[position].names[3] }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin: 32px 0; font-weight: 500; border-bottom: 1px solid #ededed; padding-bottom: 32px; margin-bottom: 0;">
                        <div style="margin-bottom: 10px; font-size: 20px;">코멘트</div>
                        <div v-html="result[position].explanation[3]" style="line-height:23px;"></div>
                        <div style="margin-top:8px; color: #606060; font-size: 14px;">{{ result[position].explanation[4] }}</div>
                    </div>
                    <div style="padding-bottom: 32px; border-bottom: 1px solid #ededed;">
                        <div style="max-width: 700px; margin: 0 auto; position: relative;">
                            <img style="width: 100%;" :src="require('@/assets/img/main_container.png')" alt="">

                            <div @click="showQr" style="position: absolute; cursor: pointer; max-width: 370px; background-color: #1e68d7; white-space: nowrap; font-size: clamp(18px, 4vw, 28px); min-width: 198px; padding: 12px 24px; line-height: 150%; border-radius: 50px; top: 59%; color: #fff; left: 50%; transform: translateX(-50%);">
                                무료로 포지션 찾기 PRO 시작
                            </div>
                        </div>
                    </div>
                    <div style="border-bottom: 1px solid #d9d9d9; padding-bottom: 30px;">
                        <div class="subTitle">{{ result[position].explanation[5] }}</div>
                        <div v-html="result[position].explanation[6]" style="margin-bottom: 24px;" class="explanation"></div>
                        <div v-html="result[position].explanation[7]" class="explanation"></div>
                    </div>
                </div>
                <div style="margin-top: 32px; border-bottom: 1px solid #ededed; padding-bottom: 32px;">
                    <div class="explanation" v-html="result[position].explanation[10]"></div>
                    <div class="explanation">{{ result[position].explanation[11] }}</div>
                </div>
            </div>
            <div style="margin: 32px auto; margin-top: 0; padding-top: 32px; padding-bottom: 32px; border-bottom: 1px solid #ededed; max-width: 700px;">
                <div style="display: flex; gap: 32px; justify-content: center;">
                    <div style="text-align: center; cursor:pointer;" @click="shareUrl">
                        <img style="width: 48px;" :src="require('@/assets/img/share_new.png')" alt="">
                        <div style="margin-top: 4px; font-size: 12px; font-weight: 500;">공유하기</div>
                        <div style="margin-top: 4px; font-size: 12px; font-weight: 500;">&nbsp;</div>
                    </div>
                    <div style="text-align: center; cursor:pointer" @click="setFeedBack('beneficial')">
                        <img style="width: 48px;" :src="require('@/assets/img/good.png')" alt="">
                        <div style="margin-top: 4px; font-size: 12px; font-weight: 500;">유익해요</div>
                        <div style="margin-top: 4px; font-size: 12px; font-weight: 500;">{{ beneficial_cnt | comma }}</div>
                    </div>
                    <div style="text-align: center; cursor:pointer" @click="setFeedBack('exact')">
                        <img style="width: 48px;" :src="require('@/assets/img/good2.png')" alt="">
                        <div style="margin-top: 4px; font-size: 12px; font-weight: 500;">정확해요</div>
                        <div style="margin-top: 4px; font-size: 12px; font-weight: 500;">{{ exact_cnt | comma }}</div>
                    </div>
                </div>
            </div>
            <!-- <div style="background-color: #18396A; text-align: center;">
                <div style="color: #fff; font-weight: 500; font-size: 20px; line-height: 24px; padding-top: 40px;">공유하고 포지션 찾기 PRO 시작하기</div>
                <div style="margin-top: 20px; text-align: center;">
                    <img style="width: 146px;" :src="require('@/assets/img/position_pro_share.png')" alt="">
                </div>
                <div style="margin-top: 20px; display: flex; gap: 12px; justify-content: center; padding-bottom: 40px;">
                    <div>
                        <img style="width: 40px;" :src="require('@/assets/img/kakao.png')" alt="">
                    </div>
                    <div>
                        <img style="width: 40px;" :src="require('@/assets/img/share.png')" alt="">
                    </div>
                </div>
            </div> -->
            <!-- <div style="background-color: #f5f5f5; text-align: center;">
                <div style="padding-top: 32px; font-weight: 500; font-size: 20px; line-height: 24px;">사커하우 APP에서 내 포지션 적용하기</div>
                <div style="margin-top: 16px; box-shadow: 4px 4px 10px 0px #8080801A; background-color: #fff; border-radius: 12px; display: flex; flex-direction: column; align-items: center;">
                    <div style="padding-top: 20px;">
                        <img style="width: 90px;" :src="require('@/assets/img/josep.png')" alt="">
                    </div>
                    <div style="margin-top: 12px; font-weight: 700; font-size: 20px; line-height: 24px;">펩 과르디올라<span style="color: var(--color-main);">CF</span></div>
                    <div style="margin-top: 8px; font-weight: 500; font-size: 14px; line-height: 24px; color: #606060; padding-bottom: 20px;">Josep Guardiola</div>
                </div>
            </div>
            <div style="font-weight: 500; line-height: 24px; text-align: center; margin-top: 16px;">지금 바로 사커하우 내 프로필에<br>내 축구 포지션을 표시할 수 있습니다!</div>
            <div style="margin-top: 16px; display: flex; justify-content: center; gap: 12px; padding-bottom: 32px;">
                <div>
                    <img style="width: 27px;" :src="require('@/assets/img/google.png')" alt="">
                </div>
                <div>
                    <img style="width: 32px;" :src="require('@/assets/img/apple.png')" alt="">
                </div>
            </div> -->
            <div style="background-color: #341A00;">
                <div style="padding: 0 20px;">
                    <div style="padding-top: 32px;">
                        <img style="width: 70px;" :src="require('@/assets/img/title.png')" alt="">
                    </div>
                    <div style="margin-top: 20px; display: flex; flex-direction: column; align-items: center;">
                        <div style="display: flex; gap: 4px; align-items: center;">
                            <div @click="showQr" style="font-weight: 700;font-size: 12px;line-height: 24px; color: var(--color-main); cursor: pointer;">{{ footerText.title1 }}</div>
                            <img style="width: 12px;" :src="require('@/assets/img/down.png')" alt="">
                        </div>
                        <div @click="showPrivacyPolicy" style="color: #fff; margin-top: 12px; font-weight: 500; font-size: 12px; line-height: 20px; cursor: pointer;">{{ footerText.title2 }}</div>
                        <div @click="showHelpPage" style="color: #fff; margin-top: 12px; font-weight: 500; font-size: 12px; line-height: 20px; padding-bottom: 32px; cursor: pointer;">{{ footerText.title3 }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isShowResult" style="display:flex; flex-direction: column; align-items: center; gap: 10px; justify-content: center; padding: 20px 0; padding-top: 0; width: 100%;">
            <div style="width: 100%;">
                <div @click="setIsShowPopup" class="complete_btn">내 프로필에 적용하기</div>
            </div>
        </div>
    </div>
</template>

<script>
import { WEB_PLATFORM_TYPE } from '@/Constants';
import ResponseCode from "../../ResponseCode";

export default {
    name: 'FindPositionLite',
    data() {
        return {
            isShowQr: false,
            isPro: false,
            qrSrc: '',
            platform: '',
            isShowPopup: false,
            target: null,
            isStep: true,
            position_result_history_group_key: null,
            scores: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
            sentence: [
                '',
                '나는 날렵하며,<br> 달리기가 빠른 편이다.',
                '나는 호기심이 많으며, 도전을<br> 걸어보거나 모험을 하는 것을 즐긴다.',
                '나는 내가 하는 행동의 결과를 믿고,<br>실패에 대한 두려움이 없는 등,<br>자신감이 높은 편이다.',
                '나는 경기를 끝까지 뛸 수 있을 정도로<br>기초 체력이 좋은 편이다.',
                '나는 동료를 잘 챙기고, 골 양보를 하는 등<br>배려심이 있는 편이다.',
                '나는 공에 대한 감각이 좋으며,<br>볼 컨트롤이나 드리블 능력이 좋다.',
                '나는 섬세한 편이며,<br>패스와 크로스, 킥 등 볼 전달<br> 능력이 좋은 편이다.',
                '나는 시야가 넓은 편이며,<br>빈공간이나 기회를 잘 옅볼 수 있다.',
                '나는 문제상황 혹은 기회를 잘 파악할<br> 수 있으며 경기의 흐름을 잘 읽는다.',
                '나는 내가 맡은 역할에 대해<br>애정과 책임감을 가지고 임하는 편이며,<br>내 포지션의 역할을 놓치지 않고 수행한다.',
                '나는 내 주변에서나<br>내가 속한 팀에서 키가 큰 편이다.',
                '내가 주로 사용하는 발은?',
            ],
            result: {
                CF: {
                    explanation: [
                        '중앙 공격수',
                        'CENTER FOWARD',
                        '중앙 공격수 (CF)',
                        '스트라이커의 역할은 이제 더 이상 골을 넣는 것에만 한정지을 수 없다.',
                        '조나단 윌슨',
                        '',
                        '재빠르며 도전적이고, 좋은 피지컬과 개인기량을<br> 갖춘 중앙 공격수 (CF)는 팀을 승리로 이끌어내는 상당히 중요한 역할을 해요! ',
                        '현대 축구에서 중앙 공격수는 빠르고, 훌륭한 마무리<br> 능력을 가지고 있어야 하며, 팀원들과 효과적인 콤비네이션 플레이를 할 수 있도록 기회를 잘 옅봐야 하죠. 최근에는 상대 수비수에게 압력을 가함으로써 수비를 지원하고 상대편의 빌드업 플레이를 저지하여 또 다른 기회를 창출하기도 해요.',
                        '골 냄새를 맡고 공을 호시탐탐 노리고 있는 거죠 :) 그냥 골을 주워 먹는 역할이라 생각할 수 있지만, 어떻게 하면 현재의 흐름에서 골을 넣을 수 있을지를 계속 생각하고, 플레이를 만들며 마무리를 지어야 하기에 생각보다 지능적으로 플레이를 해야 하죠.',
                        '동물적인 감각과 순발력!',
                        '또한 볼 득점뿐만 아니라 빌드업 되는 흐름과 상대 진영의 공간들을 잘 파악하고, 후방에 있는 선수들에게 볼을 효율적으로 패스하여 득점을 만들도록 유도하는 플레이 도 만들 수 있어야 해요.',
                        '매사에 빠르고 정확한 결정을 내릴줄 알며, 좋은 피지컬과 개인기량을 갖추어 기회가 되는 순간을 동물적인 감각으로 파악하여 마무리 지을 줄 아는   회원님, 당신은 중앙 공격수입니다 :)',
                    ],
                    images: [
                        require('@/assets/myposition_cf_로베르트 레반도프스키.png'),
                        require('@/assets/myposition_cf_헤리 케인.png'),
                        require('@/assets/myposition_cf_카림 벤제마.png'),
                        require('@/assets/myposition_cf_엘링 홀란드.png'),
                    ],
                    names: [
                        '로베르트 레반도프스키', '헤리 케인', '카림 벤제마', '엘링 홀란드'
                    ],
                    titleImage: require(`@/assets/img/position_CF.png`)
                },
                SS: {
                    explanation: [
                        '세컨드 스트라이커',
                        'SECOND STRIKER',
                        '세컨드 스트라이커 (SS)',
                        '그는 항상 스트라이커였지만 스트라이커는 아니었다.  미드필더이지만 미드필더도 아니었다.',
                        '아르센 벵거',
                        '',
                        '날카로우면서도, 폭발적이고, 뛰어난 개인기량을 통해 압박을 벗어나 공격에 가담하는 세컨컨드 스트라이커 (SS)는 중앙 공격수를 도와 득점 찬스를 만들어내거나 득점을 직접 올려 승리를 이끌어내는 역할을 해요.',
                        '현대 축구에서 세컨드 스트라이커는 빠르고 효과적으로 패스를 연계할 수 있도록 기본적인 기량이 뛰어나야 하며, 공간에 대한 지각능력과 넓은 시야각을 가지고 있어야 하죠. 상황에 따라서 직접 득점을 할 수 있도록 득점 능력까지도 좋아야하는 상당한 난이도를 가진 포지션이예요.',
                        '득점’이라는 요리를 만드는 쉐프라고 할 수 있어요. 공격형 미드필더와 차이가 없다고 생각할 수 있지만, 스트라이커로서의 역할과 공격형 미드필더로서의 역할을 같이 소화하며 활약하는만큼 공격력이 압도적으로 높아야 하는 역할이죠.',
                        '노련미 넘치는 뇌지컬과 피지컬',
                        '공간 창출, 흐름 통제, 압박 해소, 칼 같은 전진 패스, 화려하면서도 효과적인 턴 스킬 등의 퍼포먼스, 높은 득점 능력을 모두 필요로 하는만큼 상당히 지능적으로 움직여야 해요. 이 모든 것들을 소화하려면 기술적으로도 훌륭한 수준 이어야겠죠? 마치 그라운드 위의 골 기획자인 것이죠 :)',
                        '뇌지컬만큼이나 피지컬도 뛰어난   회원님, 당신은 세컨드 스트라이커입니다 :)',
                    ],
                    images: [
                        require('@/assets/myposition_ss_데니스 베르캄프.png'),
                        require('@/assets/myposition_ss_앙투안 그리즈만.png'),
                        require('@/assets/myposition_ss_알레산드로 델피에로.png'),
                        require('@/assets/myposition_ss_웨인 루니.png'),
                    ],
                    names: [
                        '데니스 베르캄프', '앙투안 그리즈만', '알레산드로 델피에로', '웨인 루니'
                    ],
                    titleImage: require(`@/assets/img/position_SS.png`)
                },
                WF: {
                    explanation: [
                        '윙 포워드',
                        'WING FOWARD',
                        '윙 포워드 (WF)',
                        '만약 축구에 마술이 존재한다면 그것은 모든 상황에 대비하기 위한 많은 훈련과 노력에서 나오는 것이다.',
                        '호나우지뉴',
                        '저돌적이고 빠른 돌파와 폭발적인 기량',
                        '빠르고 재치있는 퍼포먼스를 선보이고 공간을 휘젓고 다니면서 공격에 직접 가담하는 윙 포워드 (WF)는 빠른 스피드로 공격의 흐름을 바꿀 수 있는 역할을 해요.',
                        '현대 축구에서 윙 포워드는 저돌적으로 돌파하여 공격 찬스를 만들어내는 역할을 하는만큼 드리블면에서 기술적으로 매우 뛰어나야하며, 대체로 발 동작이 빠르거나 스피드가 빠른 선 수들이 윙 포워드 포지션에서 뛰곤 해요. 중앙으로 침투해 득점을 올려야 하는 경우도 있어 득점 능력도 상당히 우수해야 하고 체력적으로도 뛰어나야 하는 포지션이죠.',
                        '축구에서 가장 드라마틱한 포지션이라고 생각하셔도 돼요. 치고 달리면서 빠르게 올라와 중앙까지 침투, 수비수를 앞두고 한 번 접은 뒤 바로 슛. 그리고 골. 가장 축구다운 장면이 만들어지는 거죠. 물론 그만큼 개인기량이 좋아야겠지만요.',
                        '벽을 뚫는 날개짓',
                        '일반적으로 윙어는 자신이 뛰는 위치와 사용하는 발을 같이 하곤 했는데, 최근에는 사용하는 발로 슈팅을 때리기 위해 반대 측면에서 뛰는 인버티드 윙어도 전략적으로 늘어나고 있어요!',
                        '빠르고 강한 움직임으로 상대 진영을 저돌적으로 파고드는   회원님, 당신은 세컨드 스트라이커입니다 :)',
                    ],
                    images: [
                        require('@/assets/myposition_wf_리오넬 메시.png'),
                        require('@/assets/myposition_wf_손흥민.png'),
                        require('@/assets/myposition_wf_크리스티아누 호날두.png'),
                        require('@/assets/myposition_wf_킬리안 음바페.png'),
                    ],
                    names: [
                        '리오넬 메시', '손흥민', '크리스티아누 호날두', '킬리안 음바페'
                    ],
                    titleImage: require(`@/assets/img/position_WF.png`)
                },
                AM: {
                    explanation: [
                        '공격형 미드필더',
                        'ATTACKING MIDFIELDER',
                        '공격형 미드필더 (AM)',
                        '축구는 테니스가 아니다. 때로는 터프한 플레이가 필요하다.',
                        '거스 히딩크',
                        '압도적인 기량의 플레이메이커',
                        '과감하고 도전적이며 능수능란하게 공격의 판을 만들어내는 이름하여 ‘공격 기획자’ 공격형 미드필더 (AM)는 뛰어난 드리블 기술로 수비 압박을 이겨낸 후에 공격수에게 공을 정확하게 연결해주는 역할을 하죠.',
                        '현대 축구에서 공격형 미드필더는 상대의 수비 전략이 펼쳐 지는 가운데서 치열한 압박을 뚫고 공격을 연계해야 하기에 드리블 능력, 패스 전달 능력과 킥력이 전체적으로 좋아야 해요. 또 상대 수비 진영을 교묘하게 파고 들어야 하기에 위치선정 능력 또한 좋아야 하죠. 또한 압박의 강도가 점점 거세지는 현대 축구의 특성상 체력, 피지컬적으로도 많은 요구사항이 생겼어요!',
                        '레고를 가지고 놀듯’ 플레이를 한다고 생각해볼까요? 기가 막히게 수비진영을 해체하고, 공격로를 조립하여 창의적으로 골을 만들어주고 승리를 이끌어 내는 거죠! 혹은 직접 슛을 하여 골을 만들어낼 수도 있는 정말 매력적이고 ‘축구 재밌게 하는’ 포지션인 거예요.',
                        '안되는 것도 되게 한다!',
                        '매우 감각적인 움직임으로 공격을 컨트롤하는 포지션의 특성상 굉장히 창의적이고 센스티브한 패스 플레이를 종종 목격할 수 있어요. 불가능한 건 없어요. 우리팀 공격수들이 집중 마크를 당하고 있을 때도 직접 파고들거나 말도 안되는 크로스를 올려주면서 심플하게 마무리를 지을 수 있으니까요! 축구를 참 쉽게 할 수 있고, 팀의 중추가 되는 플레이메이커인   회원님, 당신은 공격형 미드필더입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_am_토마스 뮐러.png'),
                        require('@/assets/myposition_am_지네딘 지단.png'),
                        require('@/assets/myposition_am_브루노 페르난데스.png'),
                        require('@/assets/myposition_am_케빈 더 브라위너.png'),
                    ],
                    names: [
                        '토마스 뮐러', '지네딘 지단', '브루노 페르난데스', '케빈 더 브라위너'
                    ],
                    titleImage: require(`@/assets/img/position_AM.png`)
                },
                CM: {
                    explanation: [
                        '중앙 미드필더',
                        'CENTER MIDFIELDER',
                        '중앙 미드필더 (CM)',
                        '다른 것은 없다. 오직 축구공이다. 축구공을 위해 온 몸을 희생한다',
                        '크리스찬 비에리',
                        "‘공이 필요해? 지금 그라운드 어디든, 총알 배송!’",
                        '그라운드의 가장 중앙, 전략적인 요충지에서 주로 활약하며, 팀의 공,수 전략의 핵심을 담당하는 중앙 미드필더 (CM)는 중앙에서 공격, 수비에 가담하여 공을 점유하고 전달하는 핵심적인 역할을 하죠.',
                        '현대 축구에서 중앙 미드필더는 중앙에서 공을 전달해주어야 하기에 볼 배급 능력이 매우 중요하며, 중앙에서 거센 압박을 이겨내면서 공을 지켜야 되기 때문에 가장 활발하게 움직여야 해요. 즉, 체력도 좋아야 하고, 기술적인 부분도 좋아야 하죠. 또한 어느 쪽에든 공을 원활하게 전달해야 하기에 도전적이라기 보다는 안정적으로 패스를 잘 주는 게 중요한 포지션이예요.',
                        '심장은 몸 전체에 피를 전달해요. 중앙 미드필더는 그라운드의 심장인셈이죠. 어디에든 안정적으로 공을 전달할 수 있는 팀의 전략적인 코어인 거예요. 수비시에는 수비 가담도 하고, 공격시에는 공격 포인트를 만들어주는 ‘커멘드 센터’ 같은 포지션이죠!',
                        '전천후 서포터',
                        '홀딩 미드필더보다 높은 위치에서 뛰어난 체력과 활동량을 바탕으로 공,수를 오가며 다양한 역할을 수행하는 전천후 플레이어인 박스 투 박스(box to box) 미드필더는 공을 배송해주는 역할도 물론 수행하지만 여러 상황에서 팀을 도와주고 공을 받아주는 든든한 서포터 역할을 하기도 해요. 다방면으로 뛰어난 기량을 가지고 있는 만능 플레이어인 거죠.  그러나 전술의 발전으로 점점 보기 드물어지는 역할이기도 해요.',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_cm_토니 크로스.png'),
                        require('@/assets/myposition_cm_주드 벨링엄.png'),
                        require('@/assets/myposition_cm_차비 에르난데스.png'),
                        require('@/assets/myposition_cm_프랭키 더 용.png'),
                    ],
                    names: [
                        '토니 크로스', '주드 벨링엄', '차비 에르난데스', '프랭키 더 용'
                    ],
                    titleImage: require(`@/assets/img/position_CM.png`)
                },
                WM: {
                    explanation: [
                        '측면 미드필더',
                        'WIDE MIDFIELDER',
                        '측면 미드필더 (WM)',
                        '뛰어난 킥은 하루만에 만들어지지 않는다. 수천 수만 번의 노력으로 탄생하는 것이다.',
                        '데이비드 베컴',
                        '바람같은 움직임',
                        '헌신적이고, 빠른 움직임과 정확한 크로스 능력을 갖추고, 수비시엔 측면에서 압박을 가하는 측면 미드필더 (LM,RM)는 측면에서 중앙으로의 볼 배급과 동시에 상대의 볼 배급을 막아주는 역할을 해요.',
                        '현대 축구에서 윙 포워드와 측면 미드필더의 경계가 점점 모호해지는 추세이지만, 여전히 점유율 혹은 공수 밸런스를 촘촘하게 유지하는 전술에서는 다양하게 기용되죠. 주 활동 범위는 측면이지만, 활동량이 많기에 높은 체력이 요구되며, 킥력과 개인기량이 높아야 해요.',
                        '축구장 측면에서 시원한 바람처럼 움직이죠. 복잡한 빌드업이 필요한가요? 중원에서부터 압박을 이겨내고 빠르게 돌파해 골문 앞까지 얼리크로스를 올려주세요! 골까지 다이렉트로 연결해주는 거예요.',
                        '“심최몇?” 심장 최소 여러 개.',
                        '상황에 따라 오버랩핑을 해가며, 공격과 수비 양쪽을 적극적으로 가담하는 역할을 하기에 체력적으로 굉장히 뛰어나며, 놀라운 활동량을 자랑해요. 잔잔한 바람이 아닌 강철 바람인 거죠. 지치지 않는 체력으로 그라운드에 바람을 일으키는   회원님, 당신은 측면 미드필더 (LM,RM)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_wm_모하메드 살라.png'),
                        require('@/assets/myposition_wm_데이비드 베컴.png'),
                        require('@/assets/myposition_wm_루이스 피구.png'),
                        require('@/assets/myposition_wm_박지성.png'),
                    ],
                    names: [
                        '모하메드 살라', '데이비드 베컴', '루이스 피구', '박지성'
                    ],
                    titleImage: require(`@/assets/img/position_WM.png`)
                },
                DM: {
                    explanation: [
                        '수비형 미드필더',
                        'DEFENSIVE MIDFIELDER',
                        '수비형 미드필더 (DM)',
                        '공을 소유하는 것이 곧 수비이다. 우리가 공을 갖고 있을 때, 상대 팀은 공격을 할 수 없기 때문이다.',
                        '펩 과르디올라',
                        '그라운드 중앙에 세워진 높은 벽',
                        '중앙 최후방에서 공을 캐치하고, 볼을 직접적으로 연결해 경기 흐름을 순식간에 바꿀 수 있는 수비형 미드필더 (DM)은 위협적인 공격력을 가진 공격수에 압박을 가해 저지하고, 직접적으로 볼을 배급하고, 빌드업을 해나가는 역할을 해요.',
                        '현대 축구에서는 전술적으로 전방 압박을 중요시하기에 상대적으로 최후방에 있는 수비형 미드필더가 볼을 직접 배급하는 역할이 커졌어요. 대인 방어, 지역 방어와 더불어 공격 흐름을 만들기 위한 패스 능력이 뛰어나야 하기에 수비형 미드필더라는 역할은 굉장히 전문적이며, 지능적이기에 누구나 할 수 있는 쉬운 포지션은 아니죠.',
                        '가운데 세워진 벽이 공격수를 자유롭게 따라다녀요. 무서운 벽이죠. 공이 오는 것들을 모두 잘라내고 볼을 가지고 난 후부터 바로 공격이 시작되는 거예요. 수비적인 역할만 할 거라고 생각하면 안돼요. 어쩌면 현대축구에서 가장 무서운 포지션이죠.',
                        "보이지 않는 ‘발’",
                        '수비형 미드필더는 지능적인 움직임과 전술 이해도를 바탕으로 움직이는 역할인만큼 팀에서 가장 중요하고, 가장 티 안 나게 위협적인 포지션이예요. 빠르지 않고, 퍼포먼스가 부족하다고 해서 없어도 될 포지션은 아닌 거죠. 그라운드의 진정한 ‘숨은 고수’   회원님, 당신은 수비형 미드필더 (DM)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_dm_세르히오 부스케츠.png'),
                        require('@/assets/myposition_dm_안드레아 피를로.png'),
                        require('@/assets/myposition_dm_로드리.png'),
                        require('@/assets/myposition_dm_카세미루.png'),
                    ],
                    names: [
                        '세르히오 부스케츠', '안드레아 피를로', '로드리', '카세미루'
                    ],
                    titleImage: require(`@/assets/img/position_DM.png`)
                },
                WB: {
                    explanation: [
                        '윙백',
                        'WING BACK',
                        '윙백 (WB)',
                        '최고의 공격은 최고의 수비다.',
                        '호베르트 카를로스',
                        '제트엔진이 달린 강철 날개',
                        '뛰어난 체력과 지구력, 스피드를 바탕으로 공격적인 플레이를 전개하는 윙백 (LWB,RWB)은 윙 포워드, 측면 미드필더에 준하는 퍼포먼스와 활동량을 자랑하며, 측면에서 빠르고 직접적인 공격 전개를 이끌어 나가는 역할을 해요.',
                        '풀백과 비슷한 점이 있지만, 전술적으로 활동하는 위치와 역할이 다르므로, 두 포지션이 완전히 같다고는 할 수 없죠. 미드필더 위치 (2선)까지 올라와 활동하기 때문에 공격을 전개하는 것이 주된 목표인 역할이예요. 그만큼 빠른 스피드와 퍼포먼스가 요구되며 킥력, 마무리 능력도 좋아야 하죠.',
                        '비행기 날개처럼 튼튼하고 빠르게 움직여요. 상황에 따라서는 폭격을 하듯 공을 차거나, 상대 수비와의 도그 파이트에서도 지지 않는 개인기량과 퍼포먼스를 보여줘요. 사실상 수비수라는 생각보다는 또 하나의 공격수라는, ‘숨어 있는 스텔스기’라는 생각을 해야 하죠.',
                        '가짜 윙백',
                        '현대축구에서 ‘폴스 윙/풀백’이 주요 공격 자원으로 활용되는데, 윙백, 풀백의 위치상의 역할을 파괴해 측면에서 전방 안쪽까지 침투해 공격 빌드업에 가담하여 플레이를 만드는 역할을 하죠. 빠른 움직임으로 단숨에 골키퍼 코 앞까지 치고 나가는 퍼포먼스와 기량을 갖춘   회원님, 당신은 윙백 (LWB,RWB)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_wb_마르셀루.png'),
                        require('@/assets/myposition_wb_알폰소 데이비스.png'),
                        require('@/assets/myposition_wb_주앙 칸셀루.png'),
                        require('@/assets/myposition_wb_호베르트 카를로스.png'),
                    ],
                    names: [
                        '마르셀루', '알폰소 데이비스', '주앙 칸셀루', '호베르트 카를로스'
                    ],
                    titleImage: require(`@/assets/img/position_WB.png`)
                },
                FB: {
                    explanation: [
                        '풀백',
                        'FULL BACK',
                        '풀백 (FB)',
                        '풀백으로 뛰면서 그는 왼쪽 측면을 아예 자기 소유로 만들어 버리곤 했다.',
                        '필리포 갈리',
                        '측면의 수호자',
                        '윙백과 마찬가지로 빠른 스피드와, 체력을 바탕으로 측면에서 윙어를 전담하여 저지하는 풀백 (LB,RB)은 윙백보다는 좀 더 수비적인 위치에서 중앙 수비수를 지원하고, 측면 공격 전개를 집중적으로 막아내는 역할을 해요.',
                        '공격시에는 전방으로 올라가 공격에도 가담하고 다시 수비진영 까지 빠르게 내려올 수 있어야 하기에, 빠른 스피드와 좋은 체력 혹은 피지컬이 요구되죠. 주로 측면을 수호하는 역할을 하기에 수비적인 기술 (태클, 압박, 대인 방어 등)이 요구되며, 현대 축구에서는 상황에 따라 좋은 킥력과 돌파력도 겸비해야 하는 상당히 중요한 자원이죠.',
                        '영화에서나 볼법한 숨막히는 추격씬을 보는 것 같죠. 상대팀에서 가장 발이 빠른 사람을 막으러 다녀야 하니까요 상황에 따라서는 직접 공을 운반하기도 해요. 굉장한 퍼포먼스를 보여주며, 공격에 가담하는 거죠. 측면을 수호하면서 공격을 돕는 아주 좋은 서포터예요.',
                        "현대축구에서 가장 중요한 것은 ‘풀백’이다.",
                        '사실 대부분의 선수가 기피하고 다른 포지션에 비해 실력이 아주 뛰어진 않는 선수가 가야하는 비운의 위치이지만, 오히려 월드클래스로서 빛날 수 있는 희소성을 가진 포지션이죠. 그렇기 때문에 최근들어 공격 성향을 탑재한 풀백을 전술적으로 이용하는 추세죠. 수비적이며, 빠른 판단과 행동력을 갖춘   회원님, 당신은 풀백 (LB,RB)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_fb_아슈라프 하키미.png'),
                        require('@/assets/myposition_fb_카푸.png'),
                        require('@/assets/myposition_fb_트렌트 알렉산더-아놀드.png'),
                        require('@/assets/myposition_fb_파울로 말디니.png'),
                    ],
                    names: [
                        '아슈라프 하키미', '카푸', '트렌트 알렉산더-아놀드', '파울로 말디니'
                    ],
                    titleImage: require(`@/assets/img/position_FB.png`)
                },
                CB: {
                    explanation: [
                        '센터백',
                        'CENTER BACK',
                        '센터백 (CB)',
                        '반 다이크는 자신의 타이밍을 판단하고 적절한 순간을 기다리며 공격수에게 도전할 줄 아는 수비수이다.',
                        '리오넬 메시',
                        '헌신적인 방패',
                        '큰 키와 누구와도 지지 않을만큼 강하고 튼튼한 신체, 좋은 시야와 발 밑 기술을 토대로 고도의 집중력을 발휘하는 센터백 (CB)은 페널티 라인 밖에서 공과 선수를 차단하고, 수비 상황을 조율하며 세트피스 상황시 큰 키를 활용해 득점을 올리기도 하는 등의 역할을 해요.',
                        '전방 압박이 주요 전술 트렌드인 현대 축구에서 발 기술 또한 중요해졌으며, 조금이라도 방심을 하면 안되는 상황에 이르렀죠. 좋은 체격에 걸맞게 도전적으로 방어하는 역할을 하기에 높은 수준의 수비 능력 (태클, 압박, 대인 방어 등)이 요구되며, 상황에 따라 단순히 걷어내는 게 아닌 공격까지 전개될 수 있도록 정확한 킥 능력 또한 요구되죠.',
                        '패널티 라인 밖을 무섭도록 정교하게 수호하고 있어요. 초집중 상태에서 발을 들이밀고, 몸을 저돌적으로 붙이죠. 맞서 싸우거나 도망가거나 둘 중 하나를 선택하면 되지만, 도망갈 수밖에 없어요. 누구나 그럴 거죠. 까마득히 커다란 거인들이 길을 막고 서있으니까요.',
                        '세트피스 상황의 주인공',
                        '큰 체격을 가진 센터백은 세트피스 상황에서 높은 제공권을 가지고 있어요. 따라서 볼을 걷어내거나, 골을 넣는 역할에 특화되어 있죠. 어느 순간에서나 고도의 집중력을 발휘해야 되는 포지션인만큼 난이도가 굉장히 높은 포지션이예요. 우월한 체격 조건과 도전적인   회원님, 당신은 센터백 (CB)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_cb_김민재.png'),
                        require('@/assets/myposition_cb_버질 반 다이크.png'),
                        require('@/assets/myposition_cb_세르히오 라모스.png'),
                        require('@/assets/myposition_cb_파비오 칸나바로.png'),
                    ],
                    names: [
                        '김민재', '버질 반 다이크', '세르히오 라모스', '파비오 칸나바로'
                    ],
                    titleImage: require(`@/assets/img/position_CB.png`)
                },
                GK: {
                    explanation: [
                        '골키퍼',
                        'GOAL KEEPER',
                        '골키퍼 (GK)',
                    ],
                    images: [],
                    names: [],
                    titleImage: require(`@/assets/img/position_GK.png`)
                }

            },
            step: 1,
            activeBtn: false,
            rightFoot: false,
            leftFoot: false,
            footScore: 0,
            isShowResult: true,
            position: '',
            device: '',
            feedback_target: '',
            beneficial_clicked: false,
            beneficial_cnt: 0,
            exact_cnt: 0,
            exact_clicked: false,
            isSaveLog: false,
            isAppDownloadLogSaved : false,
            member_idx: -1
        }
    },
    async created() {
        this.setFeedBack = this.$Once(this.setFeedBack);
        const device = this.$cookies.get('device')
        this.device = device

        this.platform = this.$Util.getWebPlatForm()
        if (this.platform === WEB_PLATFORM_TYPE.ANDROID) {
            this.qrSrc = require('@/assets/img/android_qr.png')
        } else if (this.platform === WEB_PLATFORM_TYPE.IOS) {
            this.qrSrc = require('@/assets/img/ios_qr.png')
        } else {
            this.qrSrc = require('@/assets/img/android_qr.png')
        }

        const urlParams = new URLSearchParams(window.location.search);
        const target = urlParams.get("target")
        if (target) {
            this.target = target
        }
        const scores = JSON.parse(sessionStorage.getItem('scores'))
        if (this.target && scores) {
            this.getMemberIdx()
            this.scores = scores
            this.step = 4
        }
    },
    computed: {
        footerText() {
            return this.$i18n.messages[this.$i18n.locale].main_page.footer;
        }
    },
    methods: {
        async getMemberIdx() {
            const parameters = {}
            parameters.target = this.target

            const res = await this.$Axios.get('/api/member/decode', {params: parameters})
            this.member_idx = res.data.member_idx
        },
        setIsShowPopup() {
            this.isShowPopup = true
        },
        closePopup() {
            this.isShowPopup = false
        },
        shareUrl() {
            let url = location.origin;
            const message = '포지션 찾기 Lite';
            navigator.share({
                title: message,
                url: url
            }).then(() => {
                console.log('Thanks for sharing!');
            }).catch(() => {
                console.log('share error');
            });
        },
        async setFeedBack(feedback) {
            if (feedback === 'beneficial' && this.beneficial_clicked) {
                return;
            } else if (feedback === 'exact' && this.exact_clicked) {
                return;
            }

            if (feedback === 'beneficial') {
                this.beneficial_cnt += 1;
                this.beneficial_clicked = true;
            } else if (feedback === 'exact') {
                this.exact_cnt += 1;
                this.exact_clicked = true;
            }

            const parameters = {};
            parameters.feedback = feedback;
            parameters.feedback_target = this.feedback_target + '';

            const res = await this.$Axios.post('/api/position/save/feedback', parameters);
            if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        showHelpPage() {
            const device = this.$cookies.get('device');

            if (device !== 'pc') {
                if (JSON.parse(process.env.VUE_APP_IS_TEST_SERVER)) {
                    this.$Util.showBrowser('https://obyungear-user-test.ubiplus.co.kr/help')
                } else {
                    this.$Util.showBrowser('https://obyungear-user.ubiplus.co.kr/help')
                }
            } else {
                if (JSON.parse(process.env.VUE_APP_IS_TEST_SERVER)) {
                    window.open('https://obyungear-user-test.ubiplus.co.kr/help')
                } else {
                    window.open('https://obyungear-user.ubiplus.co.kr/help')
                }
            }
        },
        showPrivacyPolicy() {
            this.$GlobalStore.setIsShowPrivacyPolicy()
        },
        async savePosition() {

            const parameters = {};
            parameters.position = this.position;
            parameters.is_direct_position = 0;
            parameters.member_idx = this.member_idx
            if (this.position_result_history_group_key) parameters.position_result_history_group_key = this.position_result_history_group_key;

            const res = await this.$Axios.post('/api/position/save', parameters);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.goToInstallLink()
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
            this.$GlobalStore.hideProgress()
        },
        async saveProConversionLog() {
            if (this.isSaveLog) {
                return
            }
            await this.$Axios.post('/api/save/pro/conversion')
            this.isSaveLog = true
        },
        showQr(isPro = false) {
            this.saveProConversionLog()
            if (this.device === 'pc') {
                if (isPro) {
                    this.isPro = true
                }
                this.isShowQr = true
            } else {
                this.goToInstallLink()
            }

        },
        async goToApp() {
            // if(process.env.NODE_ENV === 'development'){
            //     window.location.href = "http://192.168.0.203:8080/view/home?from=position_web"
            // }else {
            //     window.location.href = "https://obyungear-user.ubiplus.co.kr/view/home?from=position_web"
            // }

            if(!this.isAppDownloadLogSaved){
                await this.$Axios.post('/api/save/log/app_download');
                this.isAppDownloadLogSaved = true;
            }

            this.goToInstallLink()
        },
        goToInstallLink() {
            const platForm = this.$Util.getWebPlatForm();
            if (platForm === WEB_PLATFORM_TYPE.ANDROID) {
                window.open('https://play.google.com/store/apps/details?id=com.ubiplus.custom.obyungear_user')
            } else if (platForm === WEB_PLATFORM_TYPE.IOS) {
                window.open('https://itunes.apple.com/app/id6443870201');
            } else {
                this.isShowQr = true
            }
        },
        closeQr() {
            this.isShowQr = false
            this.isPro = false
        },
        setScore(score, foot = false) {
            if (this.scores[this.step] === score) {
                this.$set(this.scores, this.step, 0)
            } else {
                this.$set(this.scores, this.step, score);
            }
            if (!foot && this.scores[this.step] !== 0) {
                this.activeBtn = true
            } else if (!foot && this.scores[this.step] === 0) {
                this.activeBtn = false
            }
        },
        setFootScore(score) {
            if (score === 1) {
                this.leftFoot = !this.leftFoot
            } else if (score === 3) {
                this.rightFoot = !this.rightFoot
            }

            if (this.leftFoot || this.rightFoot) {
                this.activeBtn = true
            } else {
                this.activeBtn = false
            }

            if (this.leftFoot && this.rightFoot) {
                this.footScore = 2
            } else if (this.rightFoot) {
                this.footScore = 3
            } else if (this.leftFoot) {
                this.footScore = 1
            } else {
                this.footScore = 0
            }

            this.setScore(this.footScore, true)
        },
        prevStep() {
            if (this.scores[this.step] === 0) {
                this.activeBtn = true
            }
            this.step--
        },
        async findPosition() {
            const scores = this.scores.splice(1, 12);
            const parameters = {}
            parameters.member_idx = this.member_idx
            const res = await this.$Axios.get('/api/positionCheck/' + scores.join(','), {params: parameters});

            if (res.data.code === 0) {
                this.feedback_target = res.data.target;
                this.beneficial_cnt = parseInt(res.data.beneficial_cnt);
                this.position_result_history_group_key = res.data.group_key
                this.exact_cnt = parseInt(res.data.exact_cnt);
                this.position = res.data.data[0].desc
                this.isShowResult = false;
                this.isStep = false
                sessionStorage.removeItem('scores')
            }
        },
        next(step) {
            if (step === 0) {
                this.activeBtn = false
            }
            if (this.step > 0 && this.step < 13 && !this.validate()) {
                this.$GlobalStore.showAlert('항목을 선택해주세요.');
                return;
            }
            if (this.step === 3) {
                // if (!this.target) {
                    // sessionStorage.setItem('scores', JSON.stringify(this.scores))
                    this.isShowPopup = true
                    return
                // }
            }

            if (this.step === 12 && this.footScore === 0) {
                this.$GlobalStore.showAlert('주로 사용하는 발을 선택해주세요')
                return
            }

            if (this.step === 12) {
                this.findPosition()
                return
            }
            this.step++;
        },
        validate() {
            if (this.scores[this.step] === 0) return false;
            return true;
        },
    }
}
</script>

<style scoped>
.complete_btn {
    width: calc(100% - 40px);
    line-height: 50px;
    text-align: center;
    background-color: #f5f5f5;
    border-radius: 12px;
    color: var(--color-main);
    margin: 0 auto;
    margin-top: 20px;
    font-weight: 700;
    font-size: 14px;
}
.subTitle {
    font-size: 20px;
    margin-top: 32px;
    margin-bottom: 8px;
    font-weight: 500;
    line-height: 24px;
}

.explanation {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
}

.player_name {
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    margin-top: 8px;
}

.show_position {
    width: 251px;
    margin: 0 auto;
    height: 70px;
    line-height: 70px;
    color: #fff;
    border-radius: 43px;
    background-color: #210f03;
    text-align: center;
    margin-bottom: 50px;
}

.shared {
    width: 170px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: 6px;
    background-color: #210f03;
    text-align: center;
    font-size: 14px;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
}

.one_result {
    max-width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 28px;
}

.else_result {
    max-width: 100%;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 39px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    padding: 0px 20px;
}

.many_image {
    /* justify-content: center; */
    padding-left: 35px;
    padding-right: 35px;
    gap: 12px;
    /*margin-bottom: 79px;*/
    /*margin-top: 59px;*/
    display: flex;
}

.one_image {
    text-align: center;
    margin-bottom: 48px;
    display: flex;
    justify-content: center;
}

.step1 {
    width: 325px;
    transform: scale(3.5);
    transition: transform 0.5s
}

.step2 {
    width: 325px;
    transform: scale(2.1);
    transition: transform 0.5s
}

.step3 {
    width: 325px;
    transform: scale(1.7);
    transition: transform 0.5s
}

.step4 {
    width: 325px;
    transform: scale(1);
    transition: transform 0.5s
}

.step5 {
    transform: rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents {
    transform: translateY(-112px) rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents_text {
    opacity: 1;
    transition: opacity .5s
}

.un_show_contents_text {
    opacity: 0;
}

.step1_ani1 {
    right: 17%;
    top: 42%;
}

.step1_ani2 {
    right: 53%;
    top: -53%;
}

.step1_ani3 {
    right: 117%;
    top: 220px;
}

.step1_ani4 {
    right: -56%;
    top: 186%;
}

.step1_ani5 {
    right: 33%;
    top: 223%;
}

.step1_ball {
    width: 28px;
    height: 31px;
    top: 30%;
    right: 39%;
}

.step2_ani1 {
    top: 20%;
    right: 2%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani3 {
    top: 50%;
    right: 95%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani4 {
    top: 91%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani5 {
    top: 143%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ball {
    width: 28px;
    top: -3%;
    right: 72%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.6);
}

.step3_ani1 {
    top: -44%;
    right: -17%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani3 {
    top: 22%;
    right: 106%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani4 {
    top: 27%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani5 {
    top: 96%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ball {
    width: 28px;
    top: -47%;
    right: 5%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step4_ani1 {
    top: -13%;
    right: 9%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end1 {
    top: -13%;
    right: 9%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani2 {
    top: -4%;
    right: 38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end2 {
    top: -4%;
    right: 38%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani3 {
    top: 11%;
    right: 76%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end3 {
    top: 11%;
    right: 76%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani4 {
    top: 22%;
    right: -20%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end4 {
    top: 22%;
    right: -20%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani5 {
    top: 75%;
    right: 30%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end5 {
    top: 75%;
    right: 30%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    opacity: 0;
    transition: top 1s, right 1s, transform 1s, opacity 1s;
    transform: scale(0.3);
}


.step1_circle {
    height: 60px;
    width: 60px;
    background-color: #FFCCAA;
    border-radius: 50%;
    /* box-shadow: 0px 4px 4px 0px #00000040; */
    position: absolute;
}

.first_explain_wrap {
    padding: 15px 10px 20px 10px;
    text-align: center;
    background-color: #ffece1;
    border-radius: 5px;
}

.first_explain_wrap+.first_explain_wrap {
    margin-top: 10px;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.round_wrap {
    position: relative;
    font-size: 0px;
}

.round {
    border-radius: 50%;
    /* box-shadow: 0px 4px 4px 0px #10101440; */
    background: #ededed;
}

.round_wrap+.round_wrap {
    margin-left: 21px;
}


.inner_round {
    width: 100%;
    height: 100%;
    display: none;
    background-color: blue;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-image: url('~@/assets/img/check_white.png');
    background-repeat: no-repeat;
    background-size: 22px;
    background-position: center center;
}

.common_btn {
    flex: 1;
    border-radius: 12px;
    border: 1px solid #d9d9d9;
    padding: 16px 8px;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
}


.orange_background {
    background-color: #ff7703;
}

.blue_background {
    background-color: #5f6cc3;
}

.active {
    background-color: var(--color-main);
}

.black_background {
    background-color: black;
}

.next_btn {
    border-radius: 12px;
    flex-basis: 44%;
    background-color: var(--color-main);
    padding: 12px 0;
    line-height: 24px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
}

.result_btn {
    border-radius: 12px;
    height: 40px;
    background-color: #ededed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 20px);
    color: #d9d9d9;
    font-weight: 500;
    margin-right: 20px;
    color: var(--color-main);
    font-size: 14px;
}

.prev_btn {
    flex-basis: 102px;
    height: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    margin-left: 20px;
    font-size: 14px;
    background-color: #ededed;
    font-weight: 500;
}

/* 스탭 원 */
.step_img_ani_unactive1 {
    transform: translateX(-60px)
}

.step_img_ani_active1 {
    transform: translateX(-44px)
}

.step_sub_img_ani_unactive1 {
    transform: translate(10px, -24px);
    width: 121px;
    height: 161px;
}

.step_sub_img_ani_active1 {
    transform: translate(40px, -24px);
    width: 171px;
    height: 161px;
}

/* 스탭 투 */
.step_img_ani_unactive2 {
    transform: translateX(12px) scale(1);
}

.step_img_ani_active2 {
    transform: translateX(-20px) scale(1.15);
}

.step_sub_img_ani_unactive2 {
    transform: translate(64px, 8px);
    width: 0px;
}

.step_sub_img_ani_active2 {
    transform: translate(64px, 8px);
    width: 50px;

}

/* 스탭 쓰리 */
.step_img_ani_unactive3 {
    transform: translateX(-83px) scale(0.85);
}

.step_img_ani_active3 {
    transform: translateX(-82px) scale(0.95);
}

.step_sub_img_ani_unactive3 {
    transform: translate(52px, -122px);
    opacity: 0;
}

.step_sub_img_ani_active3 {
    transform: translate(52px, -122px);
    opacity: 1;

}

/* 스텝 포 */
.step_img_ani_unactive4 {
    transform: translateX(0);
}

.step_img_ani_active4 {
    transform: translateX(30px);
}

.step_sub_img_ani_unactive4 {
    transform: translate(147px, 75px);
}

.step_sub_img_ani_active4 {
    transform: translate(176px, 77px) rotate(3deg);

}

.step_sub2_img_ani_unactive4 {
    transform: translate(-135px, 43px);
}

.step_sub2_img_ani_active4 {
    transform: translate(-97px, 53px) rotate(-20deg);

}

/* 스탭 파이브 */

.step_img_ani_unactive5 {
    transform: translateX(-35px);
}

.step_img_ani_active5 {
    transform: translateX(-35px) scale(0.8);
}

.step_sub_img_ani_unactive5 {
    transform: translate(92px, -110px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active5 {
    transform: translate(86px, -110px) rotate(-17deg) scale(0.7);
    position: relative;
    z-index: 10;

}

/* 스탭 씩스 */
.step_img_ani_unactive6 {
    transform: translateX(69px);
}

.step_img_ani_active6 {
    transform: translateX(69px) scale(1.1);
}

.step_sub_img_ani_unactive6 {
    transform: translate(144px, 11px);
    opacity: 0;
}

.step_sub_img_ani_active6 {
    transform: translate(144px, 11px);
    position: relative;
    z-index: 10;
    opacity: 1;
}

.step_sub2_img_ani_unactive6 {
    transform: translate(-156px, -1px);
}

.step_sub2_img_ani_active6 {
    transform: translate(-99px, -1px) scale(1.1);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive6 {
    transform: translate(-70px, 63px);
}

.step_sub3_img_ani_active6 {
    transform: translate(-60px, 70px) scale(1.1) rotate(-10deg);

}

.step_sub4_img_ani_unactive6 {
    transform: translate(-218px, 44px);
}

.step_sub4_img_ani_active6 {
    transform: translate(-233px, 41px) rotate(36deg);
}

/* 스탭 세븐 */
.step_img_ani_unactive7 {
    transform: translate(92px, 15px);
}

.step_img_ani_active7 {
    transform: translate(96px, 11px);
}

.step_sub_img_ani_unactive7 {
    transform: translate(254px, -13px);
    opacity: 0;
}

.step_sub_img_ani_active7 {
    transform: translate(254px, -13px);
    opacity: 1;
}

.step_sub2_img_ani_unactive7 {
    transform: translate(-11px, 77px);
}

.step_sub2_img_ani_active7 {
    transform: translate(-11px, 70px) rotate(9deg);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive7 {
    transform: translate(-99px, -62px);
}

.step_sub3_img_ani_active7 {
    transform: translate(-96px, -70px) rotate(20deg)
}

.step_sub4_img_ani_unactive7 {
    transform: translate(-36px, -76px);
}

.step_sub4_img_ani_active7 {
    transform: translate(-28px, -73px) rotate(17deg);
}

.step_sub5_img_ani_unactive7 {
    transform: translate(-135px, 14px);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active7 {
    transform: translate(-103px, 3px) rotate(-20deg);
    position: relative;
    z-index: 10;
}

.step_sub6_img_ani_unactive7 {
    transform: translate(-172px, -10px);
}

.step_sub6_img_ani_active7 {
    transform: translate(-82px, -37px);
}

/* 스탭 에잇 */
.step_img_ani_unactive8 {
    transform: translate(64px, 20px);
}

.step_img_ani_active8 {
    transform: translate(64px, 0px);
}

.step_sub_img_ani_unactive8 {
    transform: translate(31px, 5px);
    /* opacity: 0; */
}

.step_sub_img_ani_active8 {
    transform: translate(31px, 5px);
    opacity: 1;
}

.step_sub2_img_ani_unactive8 {

    transform: translate(56px, -12px);
    position: relative;
    z-index: 10;
}

.step_sub2_img_ani_active8 {
    transform: translate(-104px, -12px);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive8 {
    transform: translate(42px, -18px);
}

.step_sub3_img_ani_active8 {
    transform: translate(29px, -18px) rotate(40deg);

}

.step_sub4_img_ani_unactive8 {
    transform: translate(20px, -13px);
}

.step_sub4_img_ani_active8 {
    transform: translate(20px, -13px);
}

.step_sub5_img_ani_unactive8 {
    transform: translate(18px, 38px);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active8 {
    transform: translate(-16px, 38px);
    position: relative;
    z-index: 10;
}

/* 스텝 나인 */
.step_img_ani_unactive9 {
    transform: rotateX(0deg);
}

.step_img_ani_active9 {
    transform: rotateX(60deg);
}

/* 스텝 탠 */

.step_img_ani_unactive10 {
    transform: translate(-25px);
}

.step_img_ani_active10 {
    transform: translate(-25px);
}

.step_sub_img_ani_unactive10 {
    transform: translate(18px, -94px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active10 {
    transform: translate(25px, -102px) rotate(-34deg);
    position: relative;
    z-index: 10;
}

/* 스텝 일레븐 */

.step_img_ani_unactive11 {
    transform: translate(45px, 60px) scale(0.9);
    position: relative;
    z-index: 15;
}

.step_img_ani_active11 {
    transform: translate(45px, 66px) scale(1);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_unactive11 {
    transform: translate(107px, -71px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active11 {
    transform: translate(98px, -82px);
    position: relative;
    z-index: 15;
}

.step_sub2_img_ani_unactive11 {
    transform: translate(-46px, -43px);
    position: relative;
    z-index: 5;
}

.step_sub2_img_ani_active11 {
    transform: translate(-71px, -59px) rotate(34deg);
    position: relative;
    z-index: 5;
}

@media (max-width: 500px) {

    /* 여기에 원하는 스타일 적용 */
    .common_btn {
        min-height: 52px;
        padding: 0;
    }
}
</style>